import PublicView from '@/app/public/public.view.vue';

export const PUBLIC_ROUTES = {
  HOME: {
    NAME: 'public.home',
    PATH: 'home',
  },
  ABOUT_US: {
    NAME: 'public.aboutus',
    PATH: 'about-us',
  },
  INSTITUTION: {
    NAME: 'public.institution',
    PATH: 'institution'
  },
  REGISTER: {
    NAME: 'public.register',
    PATH: 'register'
  },
  USER_VERIFY: {
    NAME: 'public.user-verify',
    PATH: 'register/verify-user/:verificationId'
  },
  ACCEPT_INVITATION: {
    NAME: 'public.accept-invitation',
    PATH: 'register/accept-invitation/:invitationId'
  },
  COMPLETE_INVITATION: {
    NAME: 'public.complete-invitation',
    PATH: 'register/complete-invitation/:invitationId'
  },
  SUBSTITUTE_TEACHER_INVITATION: {
    NAME: 'public.substitute-teacher-invitation',
    PATH: 'register/substitute-teacher-invitation/:invitationId'
  },
  COMPLETE_USER_INVITATION: {
    NAME: 'public.complete-user-invitation',
    PATH: 'register/complete-user-invitation'
  },
  COMPLETE_SUBSTITUTE_TEACHER_INVITATION: {
    NAME: 'public.complete-substitute-teacher-invitation',
    PATH: 'register/complete-substitute-teacher-invitation'
  },
  VALIDATE_CODE: {
    NAME: 'public.validate-code',
    PATH: 'user/validate-code/:verificationId'
  },
  RESET_PASSWORD: {
    NAME: 'public.reset-password',
    PATH: 'user/reset-password/:verificationId'
  },
  PRESENTATION_MODE_WEBVIEW: {
    NAME: 'public.presentation-mode',
    PATH: 'pm/presentation-mode/:publicToken/class/:classId/menu/:id/meeting/:meetingId'
  },
}

export const PublicRoutes = { 
  path: '/',
  name: 'public',
  component: PublicView,
  children: [
    {
      path: '/',
      redirect: {
        name: PUBLIC_ROUTES.HOME.NAME
      }
    },
    {
      path: PUBLIC_ROUTES.HOME.PATH,
      component: () => import(/* HomeView */'@/app/public/home/home.vue'),
      name: PUBLIC_ROUTES.HOME.NAME
    },
    {
      path: PUBLIC_ROUTES.ABOUT_US.PATH,
      component: () => import(/* AboutView */'@/app/public/about-us/about-us.vue'),
      name: PUBLIC_ROUTES.ABOUT_US.NAME
    },
    {
      path: PUBLIC_ROUTES.INSTITUTION.PATH,
      component: () => import(/* InstitutionPrivateView */'@/app/public/institution/institution.view.vue'),
      name: PUBLIC_ROUTES.INSTITUTION.NAME
    },
    {
      path: PUBLIC_ROUTES.REGISTER.PATH,
      component: () => import(/* RegisterView */'@/app/public/register/views/register/register.view.vue'),
      name: PUBLIC_ROUTES.REGISTER.NAME
    },
    {
      path: PUBLIC_ROUTES.USER_VERIFY.PATH,
      component: () => import(/* UserVerifyView */'@/app/public/register/views/user-verify/user-verify.view.vue'),
      name: PUBLIC_ROUTES.USER_VERIFY.NAME
    },
    {
      path: PUBLIC_ROUTES.COMPLETE_INVITATION.PATH,
      component: () => import(/* CompleteInvitationView */'@/app/public/register/views/complete-invitation/complete-invitation.view.vue'),
      name: PUBLIC_ROUTES.COMPLETE_INVITATION.NAME
    },
    {
      path: PUBLIC_ROUTES.SUBSTITUTE_TEACHER_INVITATION.PATH,
      component: () => import(/* SubstituteTeacherInvitationView */'@/app/public/register/views/substitute-teacher-invitation/substitute-teacher-invitation.view.vue'),
      name: PUBLIC_ROUTES.SUBSTITUTE_TEACHER_INVITATION.NAME
    },
    {
      path: PUBLIC_ROUTES.ACCEPT_INVITATION.PATH,
      component: () => import(/* CompleteInvitationView */'@/app/public/register/views/complete-invitation/complete-invitation.view.vue'),
      name: PUBLIC_ROUTES.ACCEPT_INVITATION.NAME
    },
    {
      path: PUBLIC_ROUTES.COMPLETE_USER_INVITATION.PATH,
      component: () => import(/* CompleteUserInvitationView */'@/app/public/register/views/complete-user-invitation/complete-user-invitation.view.vue'),
      name: PUBLIC_ROUTES.COMPLETE_USER_INVITATION.NAME
    },
    {
      path: PUBLIC_ROUTES.COMPLETE_SUBSTITUTE_TEACHER_INVITATION.PATH,
      component: () => import(/* CompleteSubstituteTeacherInvitationView */'@/app/public/register/views/complete-substitute-teacher-invitation/complete-substitute-teacher-invitation.view.vue'),
      name: PUBLIC_ROUTES.COMPLETE_SUBSTITUTE_TEACHER_INVITATION.NAME
    },
    {
      path: PUBLIC_ROUTES.VALIDATE_CODE.PATH,
      component: () => import(/* ValidateCodeView */'@/auth/views/validate-code/validate-code.vue'),
      name: PUBLIC_ROUTES.VALIDATE_CODE.NAME
    },
    {
      path: PUBLIC_ROUTES.RESET_PASSWORD.PATH,
      component: () => import(/* ResetPasswordView */'@/auth/views/reset-password/reset-password.vue'),
      name: PUBLIC_ROUTES.RESET_PASSWORD.NAME
    },
    {
      path: PUBLIC_ROUTES.PRESENTATION_MODE_WEBVIEW.PATH,
      component: () => import(/* PresentationModeView */'@/app/public/web-views/presentation-mode/presentation-mode.vue'),
      name: PUBLIC_ROUTES.PRESENTATION_MODE_WEBVIEW.NAME
    },
  ],
}
